import {
    FETCHING_TENANT_CLOUDS_ACTION,
    FETCH_TENANT_CLOUDS_SUCCESS_ACTION,
    FETCH_TENANT_CLOUDS_ERROR_ACTION,
    TENANT_CLOUD_ADD_ACTION,
    TENANT_CLOUD_EDIT_ACTION,
    TENANT_CLOUD_DELETE_ACTION
} from "../actions/tenantCloudActions";

export const tenantCloudsReducer = (state = [], action) => {
    switch (action.type) {
        case FETCHING_TENANT_CLOUDS_ACTION:
            return state;
        case FETCH_TENANT_CLOUDS_SUCCESS_ACTION:
            return action.payload;
        case FETCH_TENANT_CLOUDS_ERROR_ACTION:
            return state;
        case TENANT_CLOUD_ADD_ACTION:
            return Array.isArray(state) ? [...state, action.payload] : [action.payload];
        case TENANT_CLOUD_EDIT_ACTION:
            const editedCloud = action.payload;
            return Array.isArray(state)
                ? state.map(cloud => (cloud.id === editedCloud.id ? editedCloud : cloud))
                : [editedCloud];
        case TENANT_CLOUD_DELETE_ACTION:
            return Array.isArray(state)
                ? state.filter(cloud => cloud.id !== action.payload.id)
                : [];
        default:
            return state;
    }
};
